/**
 * Builds the user-facing prompt string sent to the AI service.
 * Combines the existing comment (for refinement) with any additional teacher instructions.
 *
 * @param {string} existingComment - Current text in the comment field (may be empty)
 * @param {string} additionalInstructions - Free-form teacher notes entered in the modal
 * @returns {string} Combined user prompt
 */
export function buildUserPrompt(existingComment, additionalInstructions) {
  const parts = [];
  if (existingComment?.trim()) {
    parts.push(`Existing comment to refine:\n"${existingComment.trim()}"`);
  }
  if (additionalInstructions?.trim()) {
    parts.push(`Teacher instructions:\n${additionalInstructions.trim()}`);
  }
  return parts.join("\n\n");
}
